import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import {
  FETCH_SPOT_CONTACTS_FAILURE,
  FETCH_SPOT_CONTACTS_REQUEST,
  FETCH_SPOT_CONTACTS_SUCCESS,
} from "../../actions/targetedReachout/spotContactsActions";

const initialState = {
  spotContactsLoading: true,
  spotContactsData: [],
  spotContactsError: null,
};

const spotContactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SPOT_CONTACTS_REQUEST:
      return { ...state, spotContactsLoading: true, payload: action.payload };
    case FETCH_SPOT_CONTACTS_SUCCESS:
      return {
        ...state,
        spotContactsLoading: false,
        spotContactsData: action.payload,
      };
    case "UPDATE_CONTACT_BOOKMARK_SUCCESS":
      return {
        ...state,
        spotContactsData: state.spotContactsData.map((item) =>
          item._id === action.payload.contactId
            ? { ...item, is_bookmarked: action.payload.data }
            : item
        ),
      };
    case "UPDATE_CONTACT_READ_SUCCESS":
      return {
        ...state,
        spotContactsData: state.spotContactsData.map((item) => {
          return item._id === action.payload.contactId
            ? { ...item, is_read: action.payload.data }
            : item;
        }),
      };
    case "UPDATE_CONTACT_EMAIL_UPDATE":
      return {
        ...state,
        spotContactsData: state.spotContactsData.map((item) => {
          return item._id === action.payload.contactId
            ? { ...item, email: action.payload.data }
            : item;
        }),
      }; 
    case "UPDATE_CONTACT_PHONE_UPDATE":
      debugger
      return {
        ...state,
        spotContactsData: state.spotContactsData.map((item) => {
          if (item._id === action.payload.contactId) {
            debugger
            return{ ...item, phone: action.payload.data }
          }
          else{
           return item
          }
        }),
      };         
    case FETCH_SPOT_CONTACTS_FAILURE:
      return {
        ...state,
        spotContactsLoading: false,
        spotContactsError: action.payload,
      };
    case RESET_ALL_ACCOUNT_STATE_DEPEN:
      return initialState;
    default:
      return state;
  }
};

export default spotContactsReducer;
